// Copyright (c) 2019 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import * as React from "react";
import { connect } from "react-redux";
import { FormattedMessage, defineMessages } from "react-intl";

import { IAction } from "actions";
import { IState } from "states/states";

import RfidUserAdmin from "./RfidUserAdmin";
import EnlineUserAdmin from "./EnlineUserAdmin";

interface IUserAdminProps {
  isRfidUser: boolean;
}

const mapStateToProps = (state: IState) => {
  const props: IUserAdminProps = {
    isRfidUser: !!state.site.user?.isRfidUser,
  };
  return props;
};

interface IUserAdminDispatch {}

const mapDispatchToProps = (dispatch: (action: IAction<any>) => void) => {
  const dispatchProps: IUserAdminDispatch = {};
  return dispatchProps;
};

const messages = defineMessages({});

class UserAdminComponent extends React.Component<IUserAdminProps & IUserAdminDispatch> {
  public render() {
    if (this.props.isRfidUser) {
      return <RfidUserAdmin />;
    }
    return <EnlineUserAdmin />;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserAdminComponent);
